export { default } from './VitalsAndLabsModule';
